import React from 'react';
import IconButton from 'material-ui/IconButton';

const IconButtonExampleSimple = () => (
  <div>
    <IconButton iconClassName="muidocs-icon-custom-github" />
    <IconButton iconClassName="muidocs-icon-custom-github" disabled={true} />
  </div>
);

export default IconButtonExampleSimple;



/** WEBPACK FOOTER **
 ** ./src/app/components/pages/components/IconButton/ExampleSimple.js
 **/